module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABHNCSVQICAgIfAhkiAAAAOpJREFUWIXtl1EOgyAMhn+WXYGM4+DJpiezx9FwCPfCNiNFusySLfI9GWzsp7QgQKPxHYYbDA4eC+4AvFZiO/O5rxmZUUukxIUZ87Ul1iSfLdyw1EgsnrId6BiVfWRCBoOd0OuqPFNtYKaM7IyuhgzAF/UWry2xRlbUBkO8IslD7cTHBQeP+IK5ElDpslwHBYc+LrjZGMmUVaUJlTifUOwsMWpCwcGHG0YsGIOTr/JamyuBX1Bf47m2/7nd/nxF/SlNqEQTKtGESvyFEKlnff8SJ6RCO8EHQrkbiZCdQDDolMQIBl3uENCQ8ABQ0zfI+fwUuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/Department_course.png
// module id = K5tU
// module chunks = 1